// « L'attribuer quand même ? » (transport, lot T5b) : le serveur refuse d'attribuer un chauffeur indisponible
// (409, code « driver_unavailable ») tant que l'écran n'a pas confirmé ; après « Attribuer quand même », la même
// demande repart avec ?force_unavailable=true. Sert au menu « Attribuer » du Dispatch, à la fenêtre de course et au
// glisser-déposer du Calendrier (vue Équipe). Chez M CARWASH, le serveur ne renvoie jamais ce code : la fenêtre ne
// s'ouvre jamais.
import React, { useRef, useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";

export const DRIVER_UNAVAILABLE = "driver_unavailable";

// Réponse « Retour » : l'appelant ne montre aucun message d'erreur.
export class Abandon extends Error {}

export function useUnavailableConfirm() {
  const [detail, setDetail] = useState(null);
  const reponse = useRef(null);

  const fermer = (ok) => {
    reponse.current?.(ok);
    reponse.current = null;
    setDetail(null);
  };

  // `envoyer(force)` : la requête, avec ou sans confirmation. Renvoie sa réponse, ou lance Abandon si l'on répond
  // « Retour » ; toute autre erreur est renvoyée telle quelle.
  const withConfirm = async (envoyer) => {
    try {
      return await envoyer(false);
    } catch (e) {
      const d = e.response?.data?.detail;
      if (e.response?.status !== 409 || d?.code !== DRIVER_UNAVAILABLE) throw e;
      const ok = await new Promise((resolve) => { reponse.current = resolve; setDetail(d); });
      if (!ok) throw new Abandon();
      return envoyer(true);
    }
  };

  const motifs = [...new Set((detail?.unavailable || []).map((u) => u.reason).filter(Boolean))];
  const confirmDialog = (
    <AlertDialog open={!!detail} onOpenChange={(o) => { if (!o) fermer(false); }}>
      <AlertDialogContent data-testid="unavailable-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">Chauffeur indisponible</AlertDialogTitle>
          <AlertDialogDescription data-testid="unavailable-confirm-text">
            {detail?.message}{motifs.length > 0 && ` Motif : ${motifs.join(", ")}.`} L'attribuer quand même ?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="unavailable-confirm-no">Retour</AlertDialogCancel>
          <AlertDialogAction onClick={() => fermer(true)} data-testid="unavailable-confirm-yes">Attribuer quand même</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return { confirmDialog, withConfirm };
}
